import classNames from 'classnames'
import React from 'react'

import { Button, ButtonProps } from '../button/button.js'
import { useCurrentBreakPoint } from '../helper/hooks/use-current-breakpoint.js'
import { ChevronLeftLargeIcon } from '../icon/icon.js'

type THeadingLevel = 1 | 2 | 3
type THeadingElement = `h${THeadingLevel}`

export interface PageTitleProps {
    title: string
    alwaysButton?: boolean
    button?: Omit<ButtonProps, 'text'>
    className?: string
    element?: THeadingElement
}

export const PageTitle = (props: PageTitleProps): JSX.Element => {
    const bp = useCurrentBreakPoint()
    const isMobile = bp ? ['xs', 'sm'].includes(bp) : true

    const { alwaysButton, button, element = 'h1', title } = props

    const className: string = classNames('page-title h1', props.className)

    const renderButton = () => {
        return (
            <Button
                {...(button as ButtonProps)}
                className="page-title__button"
                iconClassName="button__icon--large"
                iconLeft={ChevronLeftLargeIcon}
                style="link"
                text={title}
            />
        )
    }

    const HeadingTag = element

    return <HeadingTag className={className}>{isMobile || alwaysButton ? renderButton() : title}</HeadingTag>
}
